import { forwardRef, useState } from 'react';
import { IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

import TextInput, { TextInputProps } from './TextInput';

export type ConfidentialInputProps = Omit<TextInputProps, 'type'> & {
  sensitiveLabel?: string;
};

const ConfidentialInput = forwardRef<HTMLInputElement, ConfidentialInputProps>(
  ({ sensitiveLabel = 'contraseña', disabled, ...textInputProps }, ref) => {
    const [isRevealed, setIsRevealed] = useState(false);

    const endAdornment = (
      <InputAdornment position='end'>
        <IconButton
          aria-label={
            isRevealed ? `Ocultar ${sensitiveLabel}` : `Mostrar ${sensitiveLabel}`
          }
          onClick={() => setIsRevealed((prev) => !prev)}
          onMouseDown={(e) => e.preventDefault()}
          edge='end'
          size='small'
          disabled={disabled}
        >
          {isRevealed ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </InputAdornment>
    );

    return (
      <TextInput
        {...textInputProps}
        ref={ref}
        type={isRevealed ? 'text' : 'password'}
        disabled={disabled}
        endAdornment={endAdornment}
      />
    );
  }
);

export default ConfidentialInput;
